var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "router-link",
    {
      staticClass: "app-logo",
      attrs: { to: _vm.link.path, alt: _vm.link.label }
    },
    [_c("img", { staticClass: "app-logo--img", attrs: { src: _vm.logoPath } })]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5db22690", { render: render, staticRenderFns: staticRenderFns })
  }
}